const Iframe = ({ source }) => {

    if (!source) {
        return <div>Loading...</div>;
    }

    const src = source;
    return (<iframe style={{border: 'none'}} src={src} width={'100%'} height={'100%'}></iframe>);
};

export default Iframe;